module.exports = __webpack_public_path__ + "img/houseVirtualrowFSFBWhiteGray.7a66187a.svg";